export enum OverlappingRuleDecision {
	SmallestWorkWin = 0,
	BiggestWorkWin = 1
}